/* eslint import/no-extraneous-dependencies: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import { FieldColour } from '@blockly/field-colour';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';
import { Matrix8x8Modal } from './customBlocks/matrix8x8Modal';
import { emptyLeds } from './customBlocks/matrix8x8Leds';
import { IconDropdown } from './customBlocks/iconDropdown';

// El generador de estos bloques es JavaScript, no Arduino.

// ------------------------------ CONTROL -------------------------------------

Blockly.Blocks.microbit_initial_block = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT);
    this.appendStatementInput('DO').appendField(Blockly.Msg.LANG_START_2);
    this.appendStatementInput('REPEAT').appendField(Blockly.Msg.LANG_REPEAT);
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_START);
  },
};

Blockly.Blocks.microbit_delay = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_DELAY);
    this.appendValueInput('NUM').setCheck(Number);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_DELAY_MS).setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_DELAY_TOOLTIP);
  },
};

Blockly.Blocks.microbit_repeat = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_CONTROLS_REPEAT_TITLE_REPEAT);
    this.appendValueInput('TIMES').setCheck(Number);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_CONTROLS_REPEAT_TITLE_TIMES).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendStatementInput('DO').appendField(Blockly.Msg.LANG_CONTROLS_DOWHILE_OPERATOR_DO);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_CONTROLS_REPEAT_TOOLTIP);
  },
};

Blockly.Blocks.microbit_button_pressed_2 = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BUTTON_PRESSED)
      .appendField(new Blockly.FieldDropdown([
        ['A', 'A'],
        ['B', 'B'],
        ['A+B', 'AB'],
      ]), 'BUTTON');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_BUTTON_PRESSED_2);
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_BUTTON_PRESSED_TOOLTIP);
  },
};

Blockly.Blocks.microbit_gesture_2 = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_IF_2)
      // IconDropdown y no FieldDropdown: el bloque muestra el texto de la opcion
      // y los iconos quedan para el desplegable, como en el set legacy.
      .appendField(new IconDropdown([
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_shake.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_SHAKE_TOOLTIP_2,
        }, 'Shake'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_tiltleft.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_TILTLEFT_TOOLTIP_2,
        }, 'TiltLeft'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_tiltright.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_TILTRIGHT_TOOLTIP_2,
        }, 'TiltRight'],
      ]), 'ICON');
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_GESTURE_TOOLTIP);
  },
};

// Variantes v1 (microbitFull). Las _2 (FIFA, microbitFull2) son bloques
// distintos, no un renombre: coexisten en prod.

Blockly.Blocks.microbit_start = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_START);
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_START);
  },
};

Blockly.Blocks.microbit_forever = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_FOREVER);
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_FOREVER);
  },
};

Blockly.Blocks.microbit_whileUntil = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    // Divergencia deliberada: las claves del legacy no existen y en prod se ve
    // "undefined"; se usan las de microbit_repeat.
    this.appendValueInput('BOOL')
      .setCheck('Boolean')
      .appendField(Blockly.Msg.LANG_CONTROLS_REPEAT_TITLE_REPEAT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_CONTROLS_WHILEUNTIL_OPERATOR_WHILE, 'WHILE'],
        [Blockly.Msg.LANG_CONTROLS_WHILEUNTIL_OPERATOR_UNTIL, 'UNTIL'],
      ]), 'MODE');
    this.appendStatementInput('DO').appendField(Blockly.Msg.LANG_CONTROLS_DOWHILE_OPERATOR_DO);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(() => Blockly.Blocks.microbit_whileUntil.TOOLTIPS[this.getFieldValue('MODE')]);
  },
};

Blockly.Blocks.microbit_whileUntil.TOOLTIPS = {
  WHILE: Blockly.Msg.LANG_CONTROLS_WHILEUNTIL_TOOLTIP_WHILE,
  UNTIL: Blockly.Msg.LANG_CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL,
};

Blockly.Blocks.microbit_button_pressed = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BUTTON_PRESSED)
      .appendField(new Blockly.FieldDropdown([
        ['A', 'A'],
        ['B', 'B'],
        ['A+B', 'AB'],
      ]), 'BUTTON');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_BUTTON_PRESSED_2);
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_BUTTON_PRESSED_TOOLTIP);
  },
};

Blockly.Blocks.microbit_pin_pressed = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_PIN_PRESSED)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_PIN_PRESSED_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'microbit',
};

Blockly.Blocks.microbit_pin_released = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_PIN_RELEASED)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_PIN_RELEASED_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'microbit',
};

// FieldDropdown y no IconDropdown: la v1 muestra el ícono sobre el bloque y
// ofrece las 11 poses, no 3.
Blockly.Blocks.microbit_gesture = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_IF)
      .appendField(new Blockly.FieldDropdown([
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_shake.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_SHAKE_TOOLTIP,
        }, 'Shake'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_logoup.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_LOGOUP_TOOLTIP,
        }, 'LogoUp'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_logodown.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_LOGODOWN_TOOLTIP,
        }, 'LogoDown'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_screenup.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_SCREENUP_TOOLTIP,
        }, 'ScreenUp'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_screendown.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_SCREENDOWN_TOOLTIP,
        }, 'ScreenDown'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_tiltleft.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_TILTLEFT_TOOLTIP,
        }, 'TiltLeft'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_tiltright.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_TILTRIGHT_TOOLTIP,
        }, 'TiltRight'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_freefall.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_FREEFALL_TOOLTIP,
        }, 'FreeFall'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_threeg.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_THREEG_TOOLTIP,
        }, 'ThreeG'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_sixg.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_SIXG_TOOLTIP,
        }, 'SixG'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_gesture_eightg.png`,
          width: 48,
          height: 48,
          alt: Blockly.Msg.LANG_GESTURE_EIGHTG_TOOLTIP,
        }, 'EightG'],
      ]), 'ICON');
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_GESTURE_TOOLTIP);
  },
};

// ------------------------------ LOGICA --------------------------------------

Blockly.Blocks.button_boolean = {
  init: function () {
    this.setColour(colors.COLOUR_LOGIC);
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setOutput(true, 'Boolean');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BUTTON)
      .appendField(new Blockly.FieldDropdown([
        ['A', 'A'],
        ['B', 'B'],
        ['A+B', 'AB'],
      ]), 'BUTTON')
      .appendField(Blockly.Msg.LANG_PRESSED);
    this.setTooltip(Blockly.Msg.LANG_BUTTON_BOOLEAN_TOOLTIP);
  },
};

Blockly.Blocks.pin_boolean = {
  init: function () {
    this.setColour(colors.COLOUR_LOGIC);
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setOutput(true, 'Boolean');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_PIN_BOOLEAN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN')
      .appendField(Blockly.Msg.LANG_IS_PRESSED);
    this.setTooltip(Blockly.Msg.LANG_PIN_BOOLEAN_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'microbit',
};

// ------------------------------ SALIDAS -------------------------------------

Blockly.Blocks.microbit_led_2 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/18.svg`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, '1'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, '0'],
      ]), 'STAT');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LED)
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LED_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'led',
};

Blockly.Blocks.microbit_led_brillo_2 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/18.svg`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_LED_BRILLO_INTENSIDAD);
    this.appendValueInput('DATOIN')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LED_BRILLO)
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('pwm', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LED_BRILLO_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'led',
};

Blockly.Blocks.microbit_play_melody_2 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/15.svg`, 60, 60));
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_PLAY_MELODY_2)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_PLAY_MELODY_DADADADUM, 'Dadadadum'],
        [Blockly.Msg.LANG_PLAY_MELODY_ENTERTAINER, 'Entertainer'],
        [Blockly.Msg.LANG_PLAY_MELODY_PRELUDE, 'Prelude'],
        [Blockly.Msg.LANG_PLAY_MELODY_ODE, 'Ode'],
        [Blockly.Msg.LANG_PLAY_MELODY_NYAN, 'Nyan'],
        [Blockly.Msg.LANG_PLAY_MELODY_RINGTONE, 'Ringtone'],
        [Blockly.Msg.LANG_PLAY_MELODY_FUNK, 'Funk'],
        [Blockly.Msg.LANG_PLAY_MELODY_BLUES, 'Blues'],
        [Blockly.Msg.LANG_PLAY_MELODY_BIRTHDAY, 'Birthday'],
        [Blockly.Msg.LANG_PLAY_MELODY_WEDDING, 'Wedding'],
        [Blockly.Msg.LANG_PLAY_MELODY_FUNERAL, 'Funeral'],
      ]), 'MELODY');
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_PLAY_MELODY_UNTILDONE, 'UntilDone'],
        [Blockly.Msg.LANG_PLAY_MELODY_INBACKGROUND, 'LoopingInBackground'],
      ]), 'OPT');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PLAY_MELODY_TOOLTIP);
  },
};

// ------------------------------ MOTORES -------------------------------------

Blockly.Blocks.microbit_motor = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/02.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MOTOR_TURN_RIGHT, '3'],
        [Blockly.Msg.LANG_MOTOR_TURN_LEFT, '4'],
        [Blockly.Msg.LANG_MOTOR_TURN_BRAKE, '6'],
      ]), 'ACTION');
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SALIDAS_MOTOR_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('motorDC', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_MOTOR_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'motordc',
};

// ------------------------------ SERVOS ---------------------------------------

Blockly.Blocks.microbit_servo_180_2 = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/14.svg`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA);
    this.appendValueInput('angulo')
      .appendField(Blockly.Msg.LANG_SERVO_180_DEGREES);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SERVO_180)
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SERVO_180_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'servo',
};

Blockly.Blocks.microbit_servo_move_millis = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/14.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MILLIS_MOVE_DEGREES);
    this.appendValueInput('angulo').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MILLIS_MOVE_MILLIS);
    this.appendValueInput('millis').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_SERVO_MILLIS_MOVE_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_SERVO_MOVE_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'servo',
};

// ------------------------------ ENTRADAS -------------------------------------

Blockly.Blocks.microbit_button_logic = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setOutput(true, 'Boolean');
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/Microbit.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_BUTTON_2)
      .appendField(new Blockly.FieldDropdown([
        ['A', 'A'],
        ['B', 'B'],
        ['A+B', 'AB'],
      ]), 'BUTTON')
      .appendField(Blockly.Msg.LANG_IS_PRESSED)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_BUTTON_READ_TOOLTIP);
  },
};

Blockly.Blocks.microbit_logo = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setOutput(true, 'Boolean');
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/Microbit.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_LOGO_PRESSED);
    this.setInputsInline(true);
  },
};

Blockly.Blocks.microbit_internal_light_level = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/Microbit_2.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_MICROBIT_LIGHT_LEVEL);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MICROBIT_LIGHT_LEVEL_TOOLTIP);
  },
};

Blockly.Blocks.microbit_color_i2c = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/181.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_COLOUR_I2C)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_LEDRGB_RED, '0'],
        [Blockly.Msg.LANG_LEDRGB_GREEN, '1'],
        [Blockly.Msg.LANG_LEDRGB_BLUE, '2'],
      ]), 'ICON')
      .appendField(Blockly.Msg.LANG_COLOUR_I2C_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_COLOUR_I2C_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'led',
};

Blockly.Blocks.microbit_color_i2c_get = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setOutput(true, 'Boolean');
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/181.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_BHOOT_LIGHT_COLOR)
      .appendField(new Blockly.FieldDropdown(
        // Mismo sensor I2C que microbit_color_i2c: comparte su clave de componente.
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${Blockly.Blocks.microbit_color_i2c.component}_PIN`),
      ), 'PIN');
    this.appendValueInput('COLOR')
      .appendField(Blockly.Msg.LANG_BHOOT_LIGHT_COLOR_IS)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_BHOOT_LIGHT_COLOR_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'led',
};

// Sin tooltip a propósito: en prod nunca lo tuvo (la clave del legacy no existe).
Blockly.Blocks.microbit_logo_event = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LOGO_EVENT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_LOGO_EVENT_PRESSED, 'Pressed'],
        [Blockly.Msg.LANG_LOGO_EVENT_TOUCHED, 'Touched'],
        [Blockly.Msg.LANG_LOGO_EVENT_RELEASED, 'Released'],
        [Blockly.Msg.LANG_LOGO_EVENT_LONG_PRESSED, 'LongPressed'],
      ]), 'EVENT')
      .appendField(Blockly.Msg.LANG_LOGO_EVENT_2);
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
  },
};

// ------------------------------ CONTROL (cont.) ------------------------------

Blockly.Blocks.microbit_while = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_CONTROLS_WHILE_OPERATOR_WHILE);
    this.appendValueInput('BOOL').setCheck('Boolean');
    this.appendStatementInput('DO').appendField(Blockly.Msg.LANG_CONTROLS_WHILE_DO);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_CONTROLS_WHILEUNTIL_TOOLTIP_WHILE);
  },
};

Blockly.Blocks.microbit_chronometer = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_START_CHONOMETER);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_CHONOMETER_TOOLTIP);
  },
};

Blockly.Blocks.microbit_chronometer_state = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_CHONOMETER);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_CHONOMETER_TOOLTIP);
  },
};

Blockly.Blocks.microbit_compare_strings = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_TEXT);
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A');
    this.appendValueInput('B').appendField('=');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_COMPARE_STRINGS_TOOLTIP);
  },
};

// ------------------------------ ENTRADAS (cont.) -----------------------------

Blockly.Blocks.microbit_internal_temperature = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/Microbit_2.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_MICROBIT_TEMPERATURE);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MICROBIT_TEMPERATURE_TOOLTIP);
  },
};

Blockly.Blocks.microbit_internal_acceleration = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/Microbit_2.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_MICROBIT_ACCELERATION)
      .appendField(new Blockly.FieldDropdown([
        ['x', 'X'],
        ['y', 'Y'],
        ['z', 'Z'],
      ]), 'AXIS');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MICROBIT_ACCELERATION_TOOLTIP);
  },
};

Blockly.Blocks.microbit_hall_effect_3 = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/Microbit_2.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_HALL_EFFECT_3)
      .appendField(new Blockly.FieldDropdown([
        ['x', 'X'],
        ['y', 'Y'],
        ['z', 'Z'],
      ]), 'AXIS');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_HALL_EFFECT_TOOLTIP);
  },
};

// ------------------------------ MOTORES (cont.) ------------------------------

// Los pines del motor doble están fijos en la placa de expansión
// (P15/P16 y P13/P14), así que estos dos bloques no llevan selector de pin.
const motorDobleActions = () => [
  [Blockly.Msg.LANG_MOTOR_DOUBLE_FORWARD_MICROBIT || 'Avanzar', '3'],
  [Blockly.Msg.LANG_MOTOR_DOUBLE_BACKWARD_MICROBIT || 'Retroceder', '4'],
  [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_RIGHT_MICROBIT || 'Girar a la derecha', '5'],
  [Blockly.Msg.LANG_MOTOR_DOUBLE_TURN_LEFT_MICROBIT || 'Girar a la izquierda', '6'],
  [Blockly.Msg.LANG_MOTOR_DOUBLE_BRAKE_MICROBIT || 'Frenar', '7'],
];

const motorSingleActions = () => [
  [Blockly.Msg.LANG_MOTOR_TURN_RIGHT || 'Girar hacia la derecha', '3'],
  [Blockly.Msg.LANG_MOTOR_TURN_LEFT || 'Girar hacia la izquierda', '4'],
  [Blockly.Msg.LANG_MOTOR_TURN_BRAKE || 'Frenar', '6'],
];

Blockly.Blocks.microbit_motor_doble = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/022.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA);
    this.appendDummyInput('PIN1')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown(motorDobleActions()), 'ACTION');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MOTOR_DOUBLE_TOOLTIP);
  },
};

Blockly.Blocks.microbit_motor_doble_speed = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/022.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA);
    this.appendDummyInput('PIN1')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown(motorDobleActions()), 'ACTION');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MOTOR_SINGLE_SPEED);
    this.appendValueInput('PWM').setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MOTOR_DOUBLE_TOOLTIP);
  },
};

Blockly.Blocks.microbit_motor_single = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/30.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('ACTION')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown(motorSingleActions()), 'ACTION');
    this.appendDummyInput('PIN1')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_MOTOR_SINGLE_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('motorPwm', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MOTOR_SINGLE_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'motor',
};

Blockly.Blocks.microbit_motor_single_speed = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/30.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('ACTION')
      .appendField(new Blockly.FieldDropdown(motorSingleActions()), 'ACTION');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MOTOR_SINGLE_SPEED);
    this.appendValueInput('PWM').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('PIN1')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_MOTOR_SINGLE_PIN)
      .appendField(new Blockly.FieldDropdown(
        // Mismo motor que microbit_motor_single: comparte su combo de pines.
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('motorPwm', `${Blockly.Blocks.microbit_motor_single.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MOTOR_SINGLE_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'motor',
};

// ------------------------------ MATRIZ 8x8 -----------------------------------

Blockly.Blocks.microbit_matrix8x8 = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATRIX_8X8)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M8x8PIN`),
      ), 'M8x8PIN');
    // Sin los inputs vacíos del legacy: el preview es el propio campo y declara
    // su tamaño. Centrado porque la imagen es más angosta que el título.
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.CENTRE)
      .appendField(new Matrix8x8Modal({ leds: emptyLeds() }, undefined, {}), 'MATRIX');
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
  getPins: function () { return ['M8x8PIN']; },
  component: 'I2C',
};

// ------------------------------ SENSORES (fifa5) -----------------------------

Blockly.Blocks.microbit_internal_sound = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/Microbit_2.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_MICROBIT_SOUND);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MICROBIT_SOUND_TOOLTIP);
  },
};

Blockly.Blocks.microbit_temperature_humidity_read = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/06.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_TEMPERATURE_2, 'temperature_C'],
        [Blockly.Msg.LANG_HUMIDITY, 'humidity'],
      ]), 'ICON')
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_TEMPERATURE_READ_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'temphumidity',
};

Blockly.Blocks.microbit_ultrasonic_2 = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/09.svg`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO)
      .appendField(Blockly.Msg.LANG_PIN);
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('ultrasonic', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'ultrasonic',
};

Blockly.Blocks.microbit_soil_read_2 = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/05.svg`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_SOIL_READ)
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_SOIL_READ_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'ldr',
};

Blockly.Blocks.microbit_joystick = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/182.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    // Cada eje del joystick esta cableado a un pin fijo, asi que el valor del
    // dropdown ES el pin que se lee.
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BHOOT_JOYSTICK)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_BHOOT_JOYSTICK_X, 'P1'],
        [Blockly.Msg.LANG_BHOOT_JOYSTICK_Y, 'P2'],
        [Blockly.Msg.LANG_BHOOT_JOYSTICK_BUTTON, 'P10'],
      ]), 'TYPE');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BHOOT_JOYSTICK_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('joystick', `${this.component}_NPIN`),
      ), 'NPIN');
    // Explícito porque v13 apila los inputs dummy seguidos; prod los pone en línea.
    this.setInputsInline(true);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_BHOOT_JOYSTICK_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'joystick',
};

Blockly.Blocks.microbit_line_follower_3 = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/19.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_3);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('joystick', `${this.component}_PIN`),
      ), 'NPIN');
    this.appendStatementInput('STACK_DERECHA').appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_DERECHA);
    this.appendStatementInput('STACK_CENTRO').appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_CENTRO);
    this.appendStatementInput('STACK_IZQUIERDA').appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_IZQUIERDA);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'lineFollower',
};

// ------------------------------ PANTALLAS (fifa5) ----------------------------

Blockly.Blocks.microbit_lcd_i2c_2 = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/30.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_I2C);
    this.appendValueInput('TEXT').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_ROW)
      .appendField(new Blockly.FieldDropdown([['0', '0'], ['1', '1']]), 'CURSOR_ROW')
      .appendField(Blockly.Msg.LANG_LCD_COLUMN)
      .appendField(new Blockly.FieldDropdown(
        Array.from({ length: 16 }, (_, i) => [String(i), String(i)]),
      ), 'CURSOR_COLUMN');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_ADDRESS)
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_16x9PIN`),
      ), '16x9PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_SHOW_TOOLTIP);
  },
  getPins: function () { return ['16x9PIN']; },
  component: 'I2C',
};

// ------------------------------ MATRIZ 8x8 (resto) ---------------------------

Blockly.Blocks.microbit_matrix8x8_text = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/matrix.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_I2C);
    this.appendValueInput('NAME').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATRIZ_TEXT_ON)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M8x8PIN`),
      ), 'M8x8PIN')
      .appendField(Blockly.Msg.LANG_MATRIZ_TEXT_PIN)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MATRIZ_TEXT_PIN_TOOLTIP);
  },
  getPins: function () { return ['M8x8PIN']; },
  component: 'I2C',
};

Blockly.Blocks.microbit_matrix8x8_draw = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/matrix.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_MATRIX8X8_DRAW_DRAW, 'LED_ON'],
        [Blockly.Msg.LANG_MATRIX8X8_DRAW_ERASE, 'LED_OFF'],
      ]), 'ACTION');
    this.appendValueInput('POSX1').appendField(Blockly.Msg.LANG_LCD_I2C_POSITIONX1).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('POSY1').appendField(Blockly.Msg.LANG_LCD_I2C_POSITIONY1).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('POSX2').appendField(Blockly.Msg.LANG_LCD_I2C_POSITIONX2).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('POSY2').appendField(Blockly.Msg.LANG_LCD_I2C_POSITIONY2).setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATRIX8X8_DRAW)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M8x8PIN`),
      ), 'M8x8PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MATRIX8X8_DRAW_TOOLTIP);
  },
  getPins: function () { return ['M8x8PIN']; },
  component: 'I2C',
};

Blockly.Blocks.microbit_matrix8x8_rotate = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/matrix.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_MATRIX8X8_ROTATE);
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([['0', '0'], ['1', '1'], ['2', '2'], ['3', '3']]), 'ACTION');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_MATRIX8X8_ROTATE_MATRIX);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATRIX8X8_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M8x8PIN`),
      ), 'M8x8PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MATRIX8X8_ROTATE_TOOLTIP);
  },
  getPins: function () { return ['M8x8PIN']; },
  component: 'I2C',
};

Blockly.Blocks.microbit_matrix8x8_invert = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/matrix.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_MATRIX8X8_INVERT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATRIX8X8_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M8x8PIN`),
      ), 'M8x8PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MATRIX8X8_INVERT_TOOLTIP);
  },
  getPins: function () { return ['M8x8PIN']; },
  component: 'I2C',
};

Blockly.Blocks.microbit_matrix8x8_clear = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/matrix.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_MATRIX8X8_CLEAR);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MATRIX8X8_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_M8x8PIN`),
      ), 'M8x8PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_MATRIX8X8_CLEAR_TOOLTIP);
  },
  getPins: function () { return ['M8x8PIN']; },
  component: 'I2C',
};

// ------------------------------ BLUETOOTH ------------------------------------

// Las etiquetas de los mensajes son una sola letra: es el primer caracter de la
// trama que manda la app, y el resto es el valor.
const bluetoothLabels = () => 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').map((l) => [l, l]);

Blockly.Blocks.microbit_bluetooth_read = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_NUMBER, 'number'],
        [Blockly.Msg.LANG_STRING, 'string'],
      ]), 'ICON')
      .appendField(Blockly.Msg.LANG_WITH_LABEL)
      .appendField(new Blockly.FieldDropdown(bluetoothLabels()), 'LABEL');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_BLUETOOTH_READ_TOOLTIP);
  },
};

Blockly.Blocks.microbit_bluetooth_send = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendValueInput('CONTENT')
      .appendField(Blockly.Msg.LANG_BLUETOOTH_SEND_MESSAGE);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_WITH_LABEL)
      .appendField(new Blockly.FieldDropdown(bluetoothLabels()), 'LABEL');
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_BLUETOOTH_SEND_MESSAGE_TOOLTIP);
  },
};

Blockly.Blocks.microbit_bluetooth_if = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_BLUETOOTH_IF);
    this.appendStatementInput('DO');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_BLUETOOTH_IF_TOOLTIP);
  },
};

// Un bloque de evento por cada dirección del joystick de la app, más los dos
// botones. La trama que manda la app es "JOY" + la letra de la dirección.
Blockly.Blocks.microbit_bluetooth_control = {
  init: function () {
    this.setColour(colors.COLOUR_COMMUNICATION);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_BLUETOOTH_CONTROL)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/joystick.svg`, options.blockWidth, options.blockHeight));

    [
      ['STACK_UP', 'arriba'],
      ['STACK_DOWN', 'abajo'],
      ['STACK_LEFT', 'izquierda'],
      ['STACK_RIGHT', 'derecha'],
      ['STACK_CENTER', 'frenar'],
    ].forEach(([input, icon]) => {
      this.appendStatementInput(input)
        .appendField(Blockly.Msg.LANG_BLUETOOTH_CONTROL_JOYSTICK)
        // Caja de 24x24 como el legacy, para que la fila no crezca; los SVG tienen
        // el viewBox recortado al dibujo para llenarla.
        .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/${icon}.svg`, 24, 24));
    });

    this.appendStatementInput('STACK_A')
      .appendField(Blockly.Msg.LANG_BLUETOOTH_CONTROL_BUTTON)
      .appendField('A');
    this.appendStatementInput('STACK_B')
      .appendField(Blockly.Msg.LANG_BLUETOOTH_CONTROL_BUTTON)
      .appendField('B');

    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_BLUETOOTH_CONTROL_TOOLTIP);
  },
};

// ------------------------------ PANTALLA (resto) -----------------------------

Blockly.Blocks.microbit_lcd_i2c_clear_2 = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/30.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_CLEAR);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_CLEAR_TOOLTIP);
  },
};

Blockly.Blocks.microbit_lcd_i2c_setBacklight = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/30.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'LOW'],
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'HIGH'],
      ]), 'STATE')
      .appendField(Blockly.Msg.LANG_LCD_SETBACKLIGHT);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_SETBACKLIGHT_TOOLTIP);
  },
};

// ------------------------------ ENTRADAS v1 (microbitFull) ------------------
// `init` es function y no arrow: el dropdown necesita `this` = bloque.
// Las fábricas reciben la clave del mensaje, no el texto: Blockly.Msg está vacío
// al cargar el módulo y appendField(undefined) deja el bloque sin etiqueta sin error.

const sensorConImagen = (image, label, tooltip, component) => ({
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/${image}`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg[label])
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg[tooltip]);
  },
  getPins: function () { return ['PIN']; },
  component,
});

// Sin imagen a propósito, como en prod.
const sensorSinImagen = (label, tooltip, component) => ({
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(Blockly.Msg[label])
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg[tooltip]);
  },
  getPins: function () { return ['PIN']; },
  component,
});

const lecturaDePin = (label, tooltip) => ({
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(Blockly.Msg[label])
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg[tooltip]);
  },
  getPins: function () { return ['PIN']; },
  component: 'microbit',
});

// --- Digitales ---
Blockly.Blocks.microbit_digital_read = lecturaDePin('LANG_DIGITAL_READ', 'LANG_DIGITAL_READ_TOOLTIP');
Blockly.Blocks.microbit_button_read = sensorConImagen('Digital_Push_Button.png', 'LANG_BUTTON_READ', 'LANG_BUTTON_READ_TOOLTIP', 'button');
Blockly.Blocks.microbit_touch_read = sensorConImagen('Capacitive_Touch_Sensor.png', 'LANG_TOUCH_READ', 'LANG_TOUCH_READ_TOOLTIP', 'touch');
Blockly.Blocks.microbit_limit_switch_read = sensorConImagen('Choque.png', 'LANG_LIMIT_SWITCH_READ', 'LANG_LIMIT_SWITCH_READ_TOOLTIP', 'switch');
Blockly.Blocks.microbit_hall_effect = sensorSinImagen('LANG_HALL_EFFECT', 'LANG_HALL_EFFECT_TOOLTIP', 'hall');
Blockly.Blocks.microbit_tilt = sensorConImagen('Digital_Tilt_Sensor.png', 'LANG_TILT', 'LANG_TILT_TOOLTIP', 'tilt');
Blockly.Blocks.microbit_ir_switch = sensorSinImagen('LANG_IR_SWITCH', 'LANG_IR_SWITCH_TOOLTIP', 'ir');
Blockly.Blocks.microbit_fire_read = sensorConImagen('Fuego.png', 'LANG_FIRE_READ', 'LANG_FIRE_READ_TOOLTIP', 'fire');
Blockly.Blocks.microbit_pir = sensorConImagen('PIR_Motion_Sensor.png', 'LANG_PIR', 'LANG_PIR_TOOLTIP', 'pir');
Blockly.Blocks.microbit_vibration = sensorConImagen('Vibracion.png', 'LANG_VIBRATION', 'LANG_VIBRATION_TOOLTIP', 'vibration');

// --- Analogicas ---
Blockly.Blocks.microbit_analog_read = lecturaDePin('LANG_ANALOG_READ', 'LANG_ANALOG_READ_TOOLTIP');
Blockly.Blocks.microbit_potentiometer_read = sensorSinImagen('LANG_POTENTIOMETER_READ', 'LANG_POTENTIOMETER_READ_TOOLTIP', 'potentiometer');
Blockly.Blocks.microbit_temperature_read = sensorConImagen('LM35_Temperature_Sensor.png', 'LANG_TEMPERATURE_READ', 'LANG_TEMPERATURE_READ_TOOLTIP', 'temperature');
Blockly.Blocks.microbit_ldr_read = sensorConImagen('Photocell_sensor.png', 'LANG_LDR_READ', 'LANG_LDR_READ_TOOLTIP', 'ldr');
Blockly.Blocks.microbit_sound_read = sensorConImagen('Analog_Sound_Sensor.png', 'LANG_SOUND_READ', 'LANG_SOUND_READ_TOOLTIP', 'sound');
Blockly.Blocks.microbit_soil_read = sensorConImagen('Soil_Humidity_Sensor.png', 'LANG_SOIL_READ', 'LANG_SOIL_READ_TOOLTIP', 'soil');
Blockly.Blocks.microbit_rain_read = sensorConImagen('Water_sensor.png', 'LANG_RAIN_READ', 'LANG_RAIN_READ_TOOLTIP', 'rain');
Blockly.Blocks.microbit_gas_read = sensorConImagen('Analog_Gas_Sensor.png', 'LANG_GAS_READ', 'LANG_GAS_READ_TOOLTIP', 'gas');
Blockly.Blocks.microbit_alcohol_read = sensorConImagen('Analog_Alcohol_Sensor.png', 'LANG_ALCOHOL_READ', 'LANG_ALCOHOL_READ_TOOLTIP', 'alcohol');
Blockly.Blocks.microbit_steam_read = sensorConImagen('Steam_Sensor.png', 'LANG_STEAM_READ', 'LANG_STEAM_READ_TOOLTIP', 'steam');
Blockly.Blocks.microbit_pressure_read = sensorConImagen('Thin_film_Pressure_Sensor.png', 'LANG_PRESSURE_READ', 'LANG_PRESSURE_READ_TOOLTIP', 'pressure');

// --- Sensores internos de la placa ---
// setOutput(true) sin tipo a propósito, como el legacy: tiparlos rompería
// conexiones que hoy funcionan con el chequeo estricto de v13.

Blockly.Blocks.input_temperature = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_TEMPERATURE);
    this.setTooltip(Blockly.Msg.LANG_TEMPERATURE_TOOLTIP);
  },
};

Blockly.Blocks.input_light_level = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_LIGHT_LEVEL);
    this.setTooltip(Blockly.Msg.LANG_LIGHT_LEVEL_TOOLTIP);
  },
};

Blockly.Blocks.input_compass = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_COMPASS);
    this.setTooltip(Blockly.Msg.LANG_COMPASS_TOOLTIP);
  },
};

Blockly.Blocks.input_acceleration = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ACCELERATION)
      .appendField(new Blockly.FieldDropdown([
        ['x', 'X'],
        ['y', 'Y'],
        ['z', 'Z'],
        [Blockly.Msg.LANG_FORCE, 'Strength'],
      ]), 'AXIS');
    this.setTooltip(Blockly.Msg.LANG_ACCELERATION_TOOLTIP);
  },
};

Blockly.Blocks.input_magnetic_force = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_MAGNETIC_FORCE)
      .appendField(new Blockly.FieldDropdown([
        ['x', 'X'],
        ['y', 'Y'],
        ['z', 'Z'],
        [Blockly.Msg.LANG_FORCE, 'Strength'],
      ]), 'AXIS');
    this.setTooltip(Blockly.Msg.LANG_MAGNETIC_FORCE_TOOLTIP);
  },
};

Blockly.Blocks.input_rotation = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ROTATION)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_ROTATION_PITCH, 'Pitch'],
        [Blockly.Msg.LANG_ROTATION_ROLL, 'Roll'],
      ]), 'DEGREES');
    this.setTooltip(Blockly.Msg.LANG_ROTATION_TOOLTIP);
  },
};

// --- Los dos de forma propia ---

// La v1 tiene un desplegable por pin; la _2 los trae juntos separados por coma.
Blockly.Blocks.microbit_ultrasonic = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/Ultrasonido.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO)
      .appendField(Blockly.Msg.LANG_PIN);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_TRIGGER)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_ECHO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN2`),
      ), 'PIN2');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_UNIT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_UNIT_CM, 'CM'],
        [Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_UNIT_IN, 'INCH'],
      ]), 'PIN3');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_ULTRASONIDO_TOOLTIP);
  },
  getPins: function () { return ['PIN', 'PIN2']; },
  component: 'ultrasonic',
};

// La v1 tiene los tres pines configurables; microbit_line_follower_3 los tiene
// fijos en P10/P1/P2.
Blockly.Blocks.microbit_line_follower = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER)
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/Line_Tracking_Sensor.png`, 60, 60));
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_DERECHA)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PINR`),
      ), 'PINR');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_CENTRO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PINC`),
      ), 'PINC');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_IZQUIERDA)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PINL`),
      ), 'PINL');
    this.appendStatementInput('STACK_DERECHA').appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_DERECHA);
    this.appendStatementInput('STACK_CENTRO').appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_CENTRO);
    this.appendStatementInput('STACK_IZQUIERDA').appendField(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_IZQUIERDA);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_LINE_FOLLOWER_TOOLTIP);
    this.contextMenu = false;
  },
  getPins: function () { return ['PINR', 'PINC', 'PINL']; },
  component: 'linefollower',
};

// ------------------------------ SALIDAS Y MOTORES v1 (microbitFull) ---------

const salidaDigital = (image, label, tooltip, component) => ({
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/${image}`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA);
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, '1'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, '0'],
      ]), 'STAT');
    this.appendDummyInput()
      .appendField(Blockly.Msg[label])
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg[tooltip]);
  },
  getPins: function () { return ['PIN']; },
  component,
});

Blockly.Blocks.microbit_led = salidaDigital('White_LED.png', 'LANG_LED', 'LANG_LED_TOOLTIP', 'led');
Blockly.Blocks.microbit_relay = salidaDigital('Relay_Module_5V.png', 'LANG_RELAY', 'LANG_RELAY_TOOLTIP', 'relay');

Blockly.Blocks.microbit_led_brillo = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/White_LED.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_LED_BRILLO_INTENSIDAD);
    this.appendValueInput('DATOIN').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LED_BRILLO)
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LED_BRILLO_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'led',
};

// Color de pantalla y no de salidas a propósito, como en el legacy.
Blockly.Blocks.microbit_colour = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, String);
    this.appendDummyInput().appendField(new FieldColour('#ff0000'), 'COLOUR');
    this.setTooltip(Blockly.Msg.LANG_COLOUR);
  },
};

Blockly.Blocks.microbit_led_rgb = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/RGB_LED.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_LEDRGB);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LEDRGB_RED)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PINR`),
      ), 'PINR');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LEDRGB_GREEN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PING`),
      ), 'PING');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LEDRGB_BLUE)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PINB`),
      ), 'PINB');
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_COLOUR)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LEDRGB_TOOLTIP);
  },
  getPins: function () { return ['PINR', 'PING', 'PINB']; },
  component: 'ledrgb',
};

// --- Musica ---

Blockly.Blocks.microbit_play_tone = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendValueInput('TONE')
      .appendField(Blockly.Msg.LANG_RINGTONE)
      .setCheck(Number);
    this.appendValueInput('BEAT').appendField(Blockly.Msg.LANG_RINGTONE_BY);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PLAY_TONE_TOOLTIP);
  },
};

// Truncado a propósito como en prod (cuatro notas y un '...' = 165); completarlo
// es una decisión de producto.
Blockly.Blocks.microbit_tones = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_TONES_C_LOW, '131'],
        [Blockly.Msg.LANG_TONES_CSHARP_LOW, '139'],
        [Blockly.Msg.LANG_TONES_D_LOW, '147'],
        [Blockly.Msg.LANG_TONES_DSHARP_LOW, '156'],
        ['...', '165'],
      ]), 'TONE');
    this.setTooltip(Blockly.Msg.LANG_TONES_TOOLTIP);
  },
};

// Sin tipo de salida, igual que el legacy: lo que emite es el nombre de una
// BeatFraction, no un número.
Blockly.Blocks.microbit_beats = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.setOutput(true);
    this.appendDummyInput()
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_BEATS_BEAT_WHOLE, 'Whole'],
        [Blockly.Msg.LANG_BEATS_BEAT_HALF, 'Half'],
        [Blockly.Msg.LANG_BEATS_BEAT_QUARTER, 'Quarter'],
        [Blockly.Msg.LANG_BEATS_BEAT_EIGHTH, 'Eighth'],
        [Blockly.Msg.LANG_BEATS_BEAT_SEXTEENTH, 'Sixteenth'],
        [Blockly.Msg.LANG_BEATS_BEAT_DOUBLE, 'Double'],
        [Blockly.Msg.LANG_BEATS_BEAT_BREVE, 'Breve'],
      ]), 'BEAT');
    this.setTooltip(Blockly.Msg.LANG_BEATS_TOOLTIP);
  },
};

// La v1 ofrece las 21 melodías y las 4 formas de repetición; microbit_play_melody_2
// tiene 11 y 2, y usa otra API de MakeCode.
Blockly.Blocks.microbit_play_melody = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_PLAY_MELODY)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_PLAY_MELODY_DADADADUM, 'Dadadadum'],
        [Blockly.Msg.LANG_PLAY_MELODY_ENTERTAINER, 'Entertainer'],
        [Blockly.Msg.LANG_PLAY_MELODY_PRELUDE, 'Prelude'],
        [Blockly.Msg.LANG_PLAY_MELODY_ODE, 'Ode'],
        [Blockly.Msg.LANG_PLAY_MELODY_NYAN, 'Nyan'],
        [Blockly.Msg.LANG_PLAY_MELODY_RINGTONE, 'Ringtone'],
        [Blockly.Msg.LANG_PLAY_MELODY_FUNK, 'Funk'],
        [Blockly.Msg.LANG_PLAY_MELODY_BLUES, 'Blues'],
        [Blockly.Msg.LANG_PLAY_MELODY_BIRTHDAY, 'Birthday'],
        [Blockly.Msg.LANG_PLAY_MELODY_WEDDING, 'Wedding'],
        [Blockly.Msg.LANG_PLAY_MELODY_FUNERAL, 'Funeral'],
        [Blockly.Msg.LANG_PLAY_MELODY_PUNCHLINE, 'Punchline'],
        [Blockly.Msg.LANG_PLAY_MELODY_BADDY, 'Baddy'],
        [Blockly.Msg.LANG_PLAY_MELODY_CHASE, 'Chase'],
        [Blockly.Msg.LANG_PLAY_MELODY_BADING, 'BaDing'],
        [Blockly.Msg.LANG_PLAY_MELODY_WAWAWAWAA, 'Wawawawaa'],
        [Blockly.Msg.LANG_PLAY_MELODY_JUMPUP, 'JumpUp'],
        [Blockly.Msg.LANG_PLAY_MELODY_JUMPDOWN, 'JumpDown'],
        [Blockly.Msg.LANG_PLAY_MELODY_POWERUP, 'PowerUp'],
        [Blockly.Msg.LANG_PLAY_MELODY_POWERDOWN, 'PowerDown'],
      ]), 'MELODY');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_REPEATING)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_PLAY_MELODY_ONCE, 'Once'],
        [Blockly.Msg.LANG_PLAY_MELODY_FOREVER, 'Forever'],
        [Blockly.Msg.LANG_PLAY_MELODY_ONCEBACKGROUND, 'OnceInBackground'],
        [Blockly.Msg.LANG_PLAY_MELODY_FOREVERBACKGROUND, 'ForeverInBackground'],
      ]), 'OPT');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_PLAY_MELODY_TOOLTIP);
  },
};

// --- Motores ---

Blockly.Blocks.microbit_servo_180 = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/Servomotor.png`, 60, 60))
      .appendField(Blockly.Msg.LANG_RAYITA);
    this.appendValueInput('angulo').appendField(Blockly.Msg.LANG_SERVO_180_DEGREES);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SERVO_180)
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('digital', `${this.component}_PIN`),
      ), 'PIN');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SERVO_180_TOOLTIP);
  },
  getPins: function () { return ['PIN']; },
  component: 'servo',
};

// ------------------------------ PANTALLAS v1 (microbitFull) -----------------

Blockly.Blocks.microbit_show_number = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendValueInput('NUM')
      .appendField(Blockly.Msg.LANG_SHOW_NUMBER)
      .setCheck(Number);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SHOW_NUMBER_TOOLTIP);
  },
};

Blockly.Blocks.microbit_show_string = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendValueInput('STR').appendField(Blockly.Msg.LANG_SHOW_STRING);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SHOW_STRING_TOOLTIP);
  },
};

Blockly.Blocks.microbit_clear_screen = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput().appendField(Blockly.Msg.LANG_CLEAR_SCREEN);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_CLEAR_SCREEN_TOOLTIP);
  },
};

// Sin input CHOICE: el shadow dropdown_show_icon_event que le cuelga el toolbox
// legacy es del bloque junior show_icon y acá no conecta a nada.
Blockly.Blocks.microbit_show_icon = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SHOW_ICON)
      .appendField(new Blockly.FieldDropdown([
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_heart.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_HEART_TOOLTIP,
        }, 'Heart'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_heart_small.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_HEART_SMALL_TOOLTIP,
        }, 'SmallHeart'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_yes.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_YES_TOOLTIP,
        }, 'Yes'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_no.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_NO_TOOLTIP,
        }, 'No'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_happy.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_HAPPY_FACE_TOOLTIP,
        }, 'Happy'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_sad.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_SAD_FACE_TOOLTIP,
        }, 'Sad'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_confused.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_CONFUSED_TOOLTIP,
        }, 'Confused'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_angry.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_ANGRY_TOOLTIP,
        }, 'Angry'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_asleep.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_ASLEEP_TOOLTIP,
        }, 'Asleep'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_surprised.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_SURPRISED_TOOLTIP,
        }, 'Surprised'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_silly.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_SILLY_TOOLTIP,
        }, 'Silly'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_fabulous.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_FABULOUS_TOOLTIP,
        }, 'Fabulous'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_meh.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_MEH_TOOLTIP,
        }, 'Meh'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_tshirt.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_TSHIRT_TOOLTIP,
        }, 'TShirt'],
        [{
          src: `${options.imgBase}/blocks/educablocks/icon_rollerskate.png`, width: 48, height: 48, alt: Blockly.Msg.LANG_SHOW_ICON_ROLLERSKATE_TOOLTIP,
        }, 'Rollerskate'],
      ]), 'ICON');
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SHOW_ICON_TOOLTIP);
  },
};

Blockly.Blocks.microbit_show_arrow = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_SHOW_ARROW)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SHOW_ARROW_NORTH, 'North'],
        [Blockly.Msg.LANG_SHOW_ARROW_NORTHEAST, 'NorthEast'],
        [Blockly.Msg.LANG_SHOW_ARROW_EAST, 'East'],
        [Blockly.Msg.LANG_SHOW_ARROW_SOUTHEAST, 'SouthEast'],
        [Blockly.Msg.LANG_SHOW_ARROW_SOUTH, 'South'],
        [Blockly.Msg.LANG_SHOW_ARROW_SOUTHWEST, 'SouthWest'],
        [Blockly.Msg.LANG_SHOW_ARROW_WEST, 'West'],
        [Blockly.Msg.LANG_SHOW_ARROW_NORTHWEST, 'NorthWest'],
      ]), 'ICON');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SHOW_ARROW_TOOLTIP);
  },
};

// La v1 deja elegir la dirección I2C en un campo de texto y la emite en cada
// llamada; la _2 la fija en 0x27 y la inicializa una sola vez.
Blockly.Blocks.microbit_lcd_i2c = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/I2C_1602.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_I2C);
    this.appendValueInput('TEXT').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_ROW)
      .appendField(new Blockly.FieldDropdown([
        ['0', '0'],
        ['1', '1'],
      ]), 'CURSOR_ROW')
      .appendField(Blockly.Msg.LANG_LCD_COLUMN)
      .appendField(new Blockly.FieldDropdown([
        ['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'],
        ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'],
        ['8', '8'], ['9', '9'], ['10', '10'], ['11', '11'],
        ['12', '12'], ['13', '13'], ['14', '14'], ['15', '15'],
      ]), 'CURSOR_COLUMN');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_ADDRESS)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('i2c', `${this.component}_PINB`),
      ), 'PINB');
    this.appendDummyInput()
      .appendField(Blockly.Msg.LANG_LCD_ADDRESS_2)
      .appendField(new Blockly.FieldTextInput('0x27'), 'LCD_DIRECCION');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_SHOW_TOOLTIP);
  },
  getPins: function () { return ['PINB']; },
  component: 'lcd',
};

Blockly.Blocks.microbit_lcd_i2c_clear = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/microbit/I2C_1602.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_RAYITA)
      .appendField(Blockly.Msg.LANG_LCD_CLEAR);
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_LCD_CLEAR_TOOLTIP);
  },
};
